// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-stastics[data-v-0b0a0f67] {\n  height: 100%;\n}\n.search-stastics .inner-table[data-v-0b0a0f67] {\n  width: 100%;\n}\n.search-stastics .inner-table[data-v-0b0a0f67] .el-table {\n  padding: 16px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
